// extracted by mini-css-extract-plugin
export default {"footer":"footer--hZBlr","terms-and-policy":"terms-and-policy--N__nr","termsAndPolicy":"terms-and-policy--N__nr","link":"link--Yo3af","devider":"devider--_SzUj"};